var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-sidebar', {
    attrs: {
      "shadow": "lg",
      "right": "",
      "width": "35%",
      "bg-variant": "white",
      "title": "Create Maintenance & Docking Plan"
    },
    on: {
      "toggle": function toggle($event) {
        _vm.show.form = !_vm.show.form;
      }
    },
    model: {
      value: _vm.show.form,
      callback: function callback($$v) {
        _vm.$set(_vm.show, "form", $$v);
      },
      expression: "show.form"
    }
  }, [_vm.show.form ? [_c('FormTargetFleetAvailabilityYearly', {
    attrs: {
      "showForm": _vm.show.form,
      "forms": _vm.form
    },
    on: {
      "refetch": _vm.onSuccessSubmit
    }
  })] : _vm._e()], 2), _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center my-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('v-multiselect', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Fleet Type",
      "label": "name",
      "options": _vm.optionsFleetTypes,
      "multiple": true,
      "required": "",
      "track-by": "id"
    },
    model: {
      value: _vm.params.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "vehicle_type_ids", $$v);
      },
      expression: "params.vehicle_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Fleet type not found.")])]), _c('date-picker', {
    staticClass: "mr-2",
    attrs: {
      "type": "year"
    },
    model: {
      value: _vm.params.year,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "year", $$v);
      },
      expression: "params.year"
    }
  }), _c('b-button', {
    staticClass: "w-100",
    staticStyle: {
      "height": "max-content",
      "max-width": "150px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click() {
        return _vm.fetchData();
      }
    }
  }, [_vm._v(" Apply Filter ")])], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "text-truncate mr-2",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "disabled": _vm.loadingExport,
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTargetAv
    }
  }, [_vm.loadingExport ? _c('b-spinner', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "16px",
      "height": "16px"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.loadingExport ? 'Loading...' : 'Export Plan By Category') + " ")], 1)], 1)]), !_vm.loading ? [_c('div', {
    staticClass: "overflow-auto relative w-100"
  }, [_c('table', {
    staticClass: "w-100 striped-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "p-2 align-middle text-center text-black",
    staticStyle: {
      "background-color": "#F2F2F2",
      "min-width": "150px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Fleet Type")]), _vm._l(_vm.months, function (month, idx) {
    return _c('th', {
      key: month,
      staticClass: "p-2 align-middle text-center text-dark",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      },
      attrs: {
        "colspan": 3
      }
    }, [_vm._v(" " + _vm._s(month.toUpperCase()) + " ")]);
  })], 2), _c('tr', [_vm._l(_vm.months, function (month, idx) {
    return [_c('th', {
      key: month + '-sub-availability',
      staticClass: "p-2 text-center text-black",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      }
    }, [_vm._v("Plan Availability")]), _c('th', {
      key: month + '-sub-breakdown',
      staticClass: "p-2 text-center text-black",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      }
    }, [_vm._v("Plan Breakdown")]), _c('th', {
      key: month + '-sub-docking',
      staticClass: "p-2 text-center text-black",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      }
    }, [_vm._v("Plan Docking")])];
  })], 2)]), _c('tbody', _vm._l(_vm.listPlanAvailabilities, function (fleet, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_c('span', {
      staticClass: "badge badge-info p-2"
    }, [_vm._v(_vm._s(fleet.name))])]), _vm._l(fleet.plan_data, function (month, idx) {
      return [_c('td', {
        key: fleet.id + '-availability-' + idx,
        staticClass: "text-center p-2",
        staticStyle: {
          "min-width": "200px"
        }
      }, [_vm._v(_vm._s(month.plan_availability) + "%")]), _c('td', {
        key: fleet.id + '-breakdown-' + idx,
        staticClass: "text-center p-2",
        staticStyle: {
          "min-width": "200px"
        }
      }, [_vm._v(_vm._s(month.plan_breakdown) + "%")]), _c('td', {
        key: fleet.id + '-docking-' + idx,
        staticClass: "text-center p-2",
        staticStyle: {
          "min-width": "200px"
        }
      }, [_vm._v(_vm._s(month.plan_docking) + "%")])];
    })], 2);
  }), 0)])]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mb-0 mr-3",
    attrs: {
      "total-rows": _vm.meta.totalItems,
      "per-page": _vm.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": function change(page) {
        _vm.meta.page = page;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.page,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "page", $$v);
      },
      expression: "meta.page"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: _vm.meta.perPage,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "perPage", $$v);
      },
      expression: "meta.perPage"
    }
  })], 1)] : _c('div', {
    staticClass: "d-flex justify-content-center p-5 w-100",
    attrs: {
      "colspan": "17"
    }
  }, [_c('b-spinner')], 1)], 2), _c('b-modal', {
    attrs: {
      "title": "Import Error Information",
      "ok-only": ""
    },
    model: {
      value: _vm.showErrImport,
      callback: function callback($$v) {
        _vm.showErrImport = $$v;
      },
      expression: "showErrImport"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "max-height": "70vh"
    }
  }, [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('th', {
    staticClass: "p-2",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Row Number")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Message")])]), _c('tbody', [_vm.msgErrImport.length ? _vm._l(_vm.msgErrImport, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "p-2 px-4"
    }, [_vm._v(_vm._s(item.rowNumber))]), _c('td', {
      staticClass: "p-2"
    }, [_vm._v(_vm._s(item.message))])]);
  }) : _vm._e()], 2)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }